import React from 'react';
//import { connect } from 'react-redux'
import {Form, FormGroup, Col} from 'react-bootstrap';
import {FormattedMessage} from 'react-intl';


class AnnotationLanguages extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div>
        <Form horizontal>

          <FormGroup controlId="formHorizontalEmail">
            <Col sm={2}>
              <strong> <FormattedMessage id={'dutch'}/></strong>
            </Col>
            <Col sm={10}/>
          </FormGroup>

          <FormGroup controlId="formHorizontalEmail">
            <Col sm={2}>
              <strong> <FormattedMessage id={'french'}/></strong>
            </Col>
            <Col sm={10}/>
          </FormGroup>

          <FormGroup controlId="formHorizontalEmail">
            <Col sm={2}>
              <strong> <FormattedMessage id={'german'}/></strong>
            </Col>
            <Col sm={10}/>
          </FormGroup>

        </Form>

      </div>
    );
  }
}


export default AnnotationLanguages;



/** WEBPACK FOOTER **
 ** ./src/modules/annotations/components/AnnotationLanguages.js
 **/